import { z } from 'zod';

/** The sender as typed, plus the value it was seeded with when the dialog opened. */
export interface SenderEmailDraft {
  value: string;
  initial: string;
}

interface SenderEmailEdit {
  /** False only when the user changed the sender to a non-address. */
  valid: boolean;
  /** Spread into the update payload; empty when the sender is untouched. */
  patch: { senderEmail?: string | null };
}

export function seedSenderEmail(
  stored: string | null | undefined,
): SenderEmailDraft {
  const initial = stored ?? '';
  return { value: initial, initial };
}

/**
 * Only a sender the user changed is validated and sent. An untouched one may
 * be a non-address stored at intake, and omitting it keeps a concurrent
 * correction from being overwritten with the value loaded when the dialog
 * opened. A blank value clears the sender.
 */
export function senderEmailEdit({
  value,
  initial,
}: SenderEmailDraft): SenderEmailEdit {
  const trimmed = value.trim();
  if (trimmed === initial.trim()) return { valid: true, patch: {} };
  return {
    valid: trimmed === '' || z.email().safeParse(trimmed).success,
    patch: { senderEmail: trimmed || null },
  };
}
